import { render, staticRenderFns } from "./QuickFilterChipsComponent.vue?vue&type=template&id=d87aa426&scoped=true&"
import script from "./QuickFilterChipsComponent.vue?vue&type=script&lang=ts&"
export * from "./QuickFilterChipsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87aa426",
  null
  
)

export default component.exports